import { useAppDispatch, useIsSelfRegistered } from '@/hooks';
import { useLogoutMutation } from '@/store/api/authApi';
import { setRulesModalOpen } from '@/store/slices/uiSlice';
import { Icons } from '@/utils/Icons';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useNavigate } from 'react-router-dom';

type UserDropdownProps = {
  isDemoUser: boolean;
  username: string;
  showBalance: boolean;
  showExposure: boolean;
  handleBalanceChange: (value: boolean) => void;
  handleExposureChange: (value: boolean) => void;
};
const UserDropdown: React.FC<UserDropdownProps> = ({
  isDemoUser,
  username,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [logout] = useLogoutMutation();
  const isSelfRegistered = useIsSelfRegistered();

  const selectItems = [
    {
      label: 'Profile',
      path: '/user/profile',
    },
    {
      label: 'Account Statement',
      path: '/user/account-statement',
    },
       {
      label: 'Set Button Values',
      path: '/user/stack-setting',
      // hideForDemo: true,
    },
    {
      label: 'Profit Loss',
      path: '/user/profit-loss',
    },
    {
      label: 'Unsettled Bets',
      // label: 'Bet History',
      path: '/user/bet-history',
    },
    
    // {
    //   label: 'Activity Logs',
    //   path: '/user/activity-logs',
    //   protected: true,
    // },
  
    {
      label: 'Casino Bet History',
      path: '/user/casino-bet-history',
      protected: true,
    },
 
    {
      label: 'Referral',
      path: '/referral',
      hideForDemo: true,
      hideForNonSelfRegistered: true,
    },
  ];

  const itemClass =
    'px-4 py-2 leading-[24px] text-sm text-white rounded-sm cursor-pointer outline-none hover:underline hover:bg-gray-100 hover:text-gray-800 text-14 focus:bg-gray-100 data-[highlighted]:bg-gray-100';

  const handleLogout = async () => {
    try {
      await logout().unwrap();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="flex items-center gap-1 px-2 py-1.5 bg-secondary-dark text-white md:text-base  transition focus:outline-none text-sm font-semibold">
          {/* <Icons.profile className=" md:text-base" /> */}
          {isDemoUser ? '' : username}
          <Icons.Down className="text-xs md:text-base" />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={5}
          className="min-w-[200px] bg-secondary text-white rounded-md shadow-lg border p-1 z-50"
        >
          {/* Dynamic navigation items */}
          {selectItems.map((item) => {
            if (item.hideForDemo && isDemoUser) return null;
            if (item.hideForNonSelfRegistered && !isSelfRegistered) return null;
            return (
              <DropdownMenu.Item
                key={item.path}
                className={itemClass}
                onSelect={() => navigate(item.path)}
              >
                {item.label}
              </DropdownMenu.Item>
            );
          })}

          {/* Redux actions */}
          {/* <DropdownMenu.Item className={itemClass} onSelect={() => dispatch(toggleEditStake())}>
            Set Button Values
          </DropdownMenu.Item> */}

          <DropdownMenu.Item
            className={`${itemClass}`}
            onSelect={() => dispatch(setRulesModalOpen(true))}
          >
            Rules
          </DropdownMenu.Item>
          {/* <DropdownMenu.Item
            className={`${itemClass} xl:hidden`}
            onSelect={(e) => {
              e.preventDefault();
              handleBalanceChange(!showBalance);
            }}
          >
            <div className="flex items-center justify-between">
              Balance <input type="checkbox" checked={showBalance} readOnly />
            </div>
          </DropdownMenu.Item>

          <DropdownMenu.Item
            className={`${itemClass} xl:hidden`}
            onSelect={(e) => {
              e.preventDefault();
              handleExposureChange(!showExposure);
            }}
          >
            <div className="flex items-center justify-between">
              Exposure <input checked={showExposure} readOnly type="checkbox" />
            </div>
          </DropdownMenu.Item> */}
          <DropdownMenu.Separator className="h-px bg-gray-200 my-1" />
          <DropdownMenu.Item className={itemClass} onSelect={handleLogout}>
            Sign Out
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default UserDropdown;
